import { render, staticRenderFns } from "./UrsprungContainer.vue?vue&type=template&id=5767fa24&"
import script from "./UrsprungContainer.vue?vue&type=script&lang=js&"
export * from "./UrsprungContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports